import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import Image from 'next/image';

import newIcon from 'public/icons/badges/new.svg';

interface Props {
  featured: boolean;
  discount: number | null;
}

const Badge: React.FC<Props> = ({ featured, discount }): JSX.Element => {
  const classes = useStyles();

  if (discount)
    return (
      <div className={classes.container}>
        <div className={classes.discountContainer}>
          <Typography variant="h3" component="span" className={classes.discountAmount}>
            -{Math.ceil(discount)}
          </Typography>

          <Typography component="span" className={classes.discountPercent}>
            %
          </Typography>
        </div>
      </div>
    );

  if (featured)
    return (
      <div className={classes.container}>
        <Image src={newIcon} />
      </div>
    );

  return <></>;
};

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
    width: 70,
    height: 70,
    overflow: 'hidden'
  },
  discountContainer: {
    position: 'absolute',
    width: '125%',
    height: '125%',
    backgroundColor: '#D882A7',
    rotate: '45deg',
    top: '-55%',
    right: '-55%',
    borderRadius: 8,
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingBottom: 4,
    gap: 2,
    paddingLeft: 4
  },
  discountAmount: {
    color: theme.palette.common.white
  },
  discountPercent: {
    color: theme.palette.common.white,
    fontSize: '0.75rem',
    marginBottom: 2
  }
}));

export default Badge;
